// extracted by mini-css-extract-plugin
module.exports = {"container":"Yq-z","disabled":"Zq-z","bgBlack":"_q-z","content":"ar-z","countdown":"br-z","topCaption":"cr-z","topHeading":"dr-z","heading":"er-z","copy":"fr-z"};